export default __webpack_public_path__ + "static/media/model-m.8ff86a39.svg";